import styled from 'styled-components'

export const InputLabel = styled.label`
  color: ${({ theme }) => theme.colors.textStrong};
  font-size: 13px;
  font-weight: 400;
  line-height: 140%;
`

export const InputWrapper = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.colors.bgSurface};
  border: 1px solid ${({ theme }) => theme.colors.borderInput};
  border-radius: 56px;
  color: ${({ theme }) => theme.colors.textStrong};
  cursor: pointer;
  display: flex;
  font-size: 13px;
  font-weight: 500;
  line-height: 140%;
  flex-direction: row;
  height: 46px;
  justify-content: flex-end;
  margin-top: 8px;
  padding: 12px;
  width: 92px;
`

export const ModalContentWrapper = styled.div`
  max-height: 80vh;
  min-width: 355px;

  & .container {
    padding: 10px 17px;
  }
`

export const ModalTitle = styled.div`
  box-shadow: inset 0px -1px 0px ${({ theme }) => theme.colors.borderDefault};
  color: ${({ theme }) => theme.colors.textTitle};
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  padding: 24px 0 12px;
  text-align: center;
`

export const Options = styled.div`
  overflow: auto;
  padding: 0 20px;
  max-height: 60vh;
`

export const Option = styled.div<{ active?: boolean }>`
  align-items: center;
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.borderDefault};
  color: #a2a5b6;
  cursor: pointer;
  display: flex;
  padding: 17px 0;

  &:hover {
    color: ${({ theme }) => theme.colors.textStrong};
  }

  ${({ active }) =>
    active &&
    `
    color: #040000;
  `}
`
